<template>
  <QTab
    :class="['sai-tab', { 'show-inactive-indicator': showInactiveIndicator }]"
    v-bind="$attrs"
    :ripple="false"
    :style="styleVariables"
  />
</template>

<script>
import { QTab } from 'quasar';

export default {
  name: 'SAITab',
  props: {
    showInactiveIndicator: Boolean,
    indicatorHeight: {
      type: String,
      default: '4px'
    }
  },
  computed: {
    styleVariables() {
      return {
        '--indicator-height': this.indicatorHeight
      };
    }
  },
  components: {
    QTab
  }
};
</script>

<style lang="sass" scoped>
.sai-tab::v-deep
  .q-tab__indicator
    height: var(--indicator-height)

  &.show-inactive-indicator:not(.q-tab--active)
    .q-tab__indicator
      opacity: 1 !important
      background: $grey-4
</style>
